export default __webpack_public_path__ + "img/bg-tab1and2_nav9-f4c585fb.png";